
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17.8 14.99"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Layer_1-2","data-name":"Layer 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M13.13 9.45l-.23-.31-.62 1A4.62 4.62 0 0 1 13 12.7a4.81 4.81 0 0 1-.15 1.2H14a6 6 0 0 0 .12-1.2 5.69 5.69 0 0 0-.99-3.25zM8.38 8a4.4 4.4 0 0 1 1 .12l1-.85a5.62 5.62 0 0 0-2-.36 5.76 5.76 0 0 0-5.75 5.79 6 6 0 0 0 .12 1.2h1.13a4.4 4.4 0 0 1-.16-1.2A4.66 4.66 0 0 1 8.38 8zM8.52 13.37a1.5 1.5 0 0 1-1-.38 1.52 1.52 0 0 1-.14-2.16L13.66 6l-3.95 6.82a1.52 1.52 0 0 1-1.19.55zm-.36-1.79a.45.45 0 0 0 .07.59.43.43 0 0 0 .59 0L10 10.22z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M16.09 15H1.71A1.72 1.72 0 0 1 0 13.28V1.71A1.72 1.72 0 0 1 1.71 0h11.77a1.12 1.12 0 0 1 .8.33l3.19 3.19a1.14 1.14 0 0 1 .33.8v9A1.72 1.72 0 0 1 16.09 15zM1.71 1.09a.62.62 0 0 0-.62.62v11.57a.62.62 0 0 0 .62.62h14.38a.62.62 0 0 0 .62-.62v-9l-3.2-3.18H1.71z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M13.32 4.46a2.06 2.06 0 0 0 1.46.61h1.92v-.75L16.38 4h-1.6a.94.94 0 0 1-.69-.29A1 1 0 0 1 13.8 3V1.39l-.29-.29h-.8V3a2 2 0 0 0 .61 1.46z"}})])])])
          )
        }
      }
    